let initialState = {
    visitors : [],
};

const visitorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VISITORS" : 
      return {
        ...state,
        visitors : action.payload
      }   
    default : return state
  }

}

export { visitorReducer }
